 import { useAuthStore } from '@/stores/useAuthStore';
 import { initializeEcho } from '@night-owl-elite/vue3-ws'

export function setupWebSockets() {
  const authStore = useAuthStore();
  const tokenGetter = () => authStore?.getUserToken || '';

  initializeEcho({
    key: import.meta.env.VITE_USER_PUSHER_APP_KEY || '',
    cluster: import.meta.env.VITE_USER_PUSHER_APP_CLUSTER || 'mt1',
    host: import.meta.env.VITE_USER_PUSHER_HOST,
    port: import.meta.env.VITE_USER_PUSHER_PORT,
    scheme: import.meta.env.VITE_USER_PUSHER_SCHEME,
    authEndpoint: import.meta.env.VITE_USER_WEBSOCKET_ENDPOINT,
    token: tokenGetter
  }, 'user');

   initializeEcho({
    key: import.meta.env.VITE_PUSHER_APP_KEY || '',
    cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER || 'mt1',
    host: import.meta.env.VITE_PUSHER_HOST,
    port: import.meta.env.VITE_PUSHER_PORT,
    scheme: import.meta.env.VITE_PUSHER_SCHEME,
    authEndpoint: import.meta.env.VITE_WEBSOCKET_ENDPOINT || '/api/broadcasting/auth',
    token: tokenGetter
  }, 'default');


}
